jQuery( () => {
	const elasticSearchLoader = document.querySelector( '.js-elastic-search-loader' );

	wp.hooks.addAction( 'qalaElasticCore.action.onResult.results', 'QalaTheme', () => {
		if ( ! elasticSearchLoader ) {
			return;
		}

		const hideClass = 'is-hidden';
		if ( elasticSearchLoader.classList.contains( hideClass ) ) {
			return;
		}

		elasticSearchLoader.classList.add( hideClass );
	} );
} );
